import { Skeleton } from "antd";
import { useSelector } from "react-redux";
import DashboardBadge from "../DashboardBadge";
import DashboardPreviewInfo from "../DashboardPreviewInfo";

function TasksPreview() {
  const {
    dashboard: {
      taskInfoStatus,
      taskInfo: { tasks_info: { collapsed_preview = {} } = {} },
    },
  } = useSelector((state) => state);

  const { badge_text, summary_text } = collapsed_preview;

  return (
    <>
      {taskInfoStatus === "loading" && (
        <>
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
        </>
      )}

      {taskInfoStatus === "success" && (
        <>
          <DashboardBadge type="primary">{badge_text}</DashboardBadge>
          <DashboardPreviewInfo>{summary_text}</DashboardPreviewInfo>
        </>
      )}
    </>
  );
}

export default TasksPreview;
